// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-header {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  margin-left: 0px;
  margin-right: 0px;
}

.dashboard-toggle-button {
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  min-width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-toggle-button:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.dashboard-toggle-button:active {
  transform: scale(0.97);
}

.urgent-orders-list {
  max-height: 420px;
  overflow-y: auto;
}

.urgent-order-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 4px;
  background: white;
}

.urgent-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.urgent-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.urgent-dot.red {
  background: #dc2626;
}

.urgent-dot.orange {
  background: #ea580c;
}

.urgent-dot.yellow {
  background: #ca8a04;
}

.active-drivers-dot.green {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  display: inline-block;
}

.active-drivers-dot.red {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #dc2626;
  display: inline-block;
}

.urgent-order-card strong {
  font-size: 13px;
  color: #111827;
}

.urgent-order-card p {
  margin: 2px 0 0;
  font-size: 12px;
  color: #6b7280;
}

.urgent-order-card span {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
}

.urgent-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 0;
}

.bottom-grid-dispatcher {
  display: grid;
  grid-template-columns: 1.5fr 2fr 1.5fr;
  gap: 16px;
  margin-top: 20px;
}

.active-drivers-box td {
  padding: 10px 0;
  font-size: 12px;
  font-weight: 700;
}

.active-drivers-box .dName {
  text-align: left;
}

.active-drivers-box tr {
  border-bottom: 1px dotted #4b4848;
}

.active-drivers-box tr:last-child {
  border-bottom: none;
}

.active-drivers-box table {
  width: 100%;
  font-size: 12px;
  border-collapse: collapse;
}

.active-drivers-box th {
  text-align: center;
  color: #6b7280;
  font-weight: 500;
  padding: 0 8px;
  border-right: 1px dotted #4b4848;
}

.active-drivers-box {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  align-items: center;
}

.urgent-orders-box {
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.urgent-orders-box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.urgent-orders-box-header h4 {
  font-size: 14px;
  font-weight: 600;
}

.urgent-orders-box-header span {
  font-size: 12px;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 15px;
}

.show-all-btn {
  cursor: pointer;
  color: #3b82f6;
  background: none;
  border: none;
  font-size: 12px;
  font-weight: 500;
  padding-top: 20px;
}

.urgent-assign-btn {
  flex-shrink: 0;
  padding: 3px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition:
    opacity 0.2s,
    transform 0.15s;
}
.urgent-assign-btn:hover {
  opacity: 0.85;
  transform: scale(1.04);
}

.urgent-assign-btn--red,
.urgent-assign-btn--orange,
.urgent-assign-btn--yellow {
  border-radius: 5px;
  height: 27px;
  border: 1px solid lightgray;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  padding: 5px;
}

.urgent-delay-label {
  font-size: 11px;
  color: #9ca3af;
  margin: 2px 0 0 0;
}

.dName--clickable {
  cursor: pointer;
  transition: color 0.15s;
}
.dName--clickable:hover {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 700;
}

.driver-orders-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.driver-orders-modal {
  background: #fff;
  border-radius: 16px;
  width: 420px;
  max-width: 94vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: modalSlideIn 0.2s ease;
}

@keyframes modalSlideIn {
  from {
    transform: translateY(24px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.driver-orders-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 12px;
  border-bottom: 1px solid #f0f0f0;
}
.driver-orders-modal__title-group {
  display: flex;
  align-items: center;
}
.driver-orders-modal__title {
  font-size: 17px;
  font-weight: 700;
  color: #111;
  margin: 0;
}
.driver-orders-modal__close {
  background: #f3f4f6;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 13px;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.driver-orders-modal__close:hover {
  background: #e5e7eb;
}

.driver-orders-modal__subheader {
  padding: 8px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.driver-orders-modal__badge {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  background: #e5e7eb;
  padding: 3px 10px;
  border-radius: 20px;
  flex-shrink: 0;
}
.driver-orders-modal__optimize-btn {
  margin-left: auto;
  font-size: 12px;
  padding: 4px 10px;
  flex-shrink: 0;
}

.driver-orders-modal__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.driver-orders-modal__loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 0;
  color: #9ca3af;
  font-size: 14px;
}
.driver-orders-modal__spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.driver-orders-modal__empty {
  text-align: center;
  padding: 48px 0;
  color: #9ca3af;
  font-size: 14px;
}

.driver-order-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 16px;
  background: #fff;
  transition: box-shadow 0.15s;
}
.driver-order-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.driver-order-card__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.driver-order-card__id {
  font-size: 14px;
  font-weight: 700;
  color: #111;
}
.driver-order-card__status {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
}
.status--assigned {
  background: #dbeafe;
  color: #1d4ed8;
}
.status--picked {
  background: #fef3c7;
  color: #92400e;
}
.status--onway {
  background: #d1fae5;
  color: #065f46;
}

.driver-order-card__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
.driver-order-card__amount {
  font-size: 15px;
  font-weight: 700;
  color: #2563eb;
}
.driver-order-card__delay {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
}
.delay--late {
  background: #fee2e2;
  color: #dc2626;
}
.delay--ok {
  background: #dcfce7;
  color: #16a34a;
}

.driver-order-card__addresses {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.driver-order-card__addr-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #374151;
}
.addr-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}
.addr-dot--pickup {
  background: #3b82f6;
}
.addr-dot--drop {
  background: #10b981;
}
.addr-text {
  color: #6b7280;
}

.driver-active-count {
  display: inline-block;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  min-width: 24px;
  text-align: center;
  border-radius: 50%;
  margin: 0px;
}

.driver-active-count-span {
  display: flex;
  justify-content: center;
  align-items: right;
}
`, "",{"version":3,"sources":["webpack://./src/Css/DispatcherDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf;;mBAEiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,oEAAoE;EACpE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".dashboard-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 50px;\r\n  margin-left: 0px;\r\n  margin-right: 0px;\r\n}\r\n\r\n.dashboard-toggle-button {\r\n  padding: 10px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  color: #1f2937;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n  min-width: 120px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.dashboard-toggle-button:hover {\r\n  background: #f3f4f6;\r\n  border-color: #9ca3af;\r\n}\r\n\r\n.dashboard-toggle-button:active {\r\n  transform: scale(0.97);\r\n}\r\n\r\n.urgent-orders-list {\r\n  max-height: 420px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.urgent-order-card {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 4px;\r\n  background: white;\r\n}\r\n\r\n.urgent-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.urgent-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.urgent-dot.red {\r\n  background: #dc2626;\r\n}\r\n\r\n.urgent-dot.orange {\r\n  background: #ea580c;\r\n}\r\n\r\n.urgent-dot.yellow {\r\n  background: #ca8a04;\r\n}\r\n\r\n.active-drivers-dot.green {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #22c55e;\r\n  display: inline-block;\r\n}\r\n\r\n.active-drivers-dot.red {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #dc2626;\r\n  display: inline-block;\r\n}\r\n\r\n.urgent-order-card strong {\r\n  font-size: 13px;\r\n  color: #111827;\r\n}\r\n\r\n.urgent-order-card p {\r\n  margin: 2px 0 0;\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.urgent-order-card span {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n}\r\n\r\n.urgent-divider {\r\n  border: none;\r\n  border-top: 1px solid #e5e7eb;\r\n  margin: 0;\r\n}\r\n\r\n.bottom-grid-dispatcher {\r\n  display: grid;\r\n  grid-template-columns: 1.5fr 2fr 1.5fr;\r\n  gap: 16px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.active-drivers-box td {\r\n  padding: 10px 0;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n.active-drivers-box .dName {\r\n  text-align: left;\r\n}\r\n\r\n.active-drivers-box tr {\r\n  border-bottom: 1px dotted #4b4848;\r\n}\r\n\r\n.active-drivers-box tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.active-drivers-box table {\r\n  width: 100%;\r\n  font-size: 12px;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.active-drivers-box th {\r\n  text-align: center;\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  padding: 0 8px;\r\n  border-right: 1px dotted #4b4848;\r\n}\r\n\r\n.active-drivers-box {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  align-items: center;\r\n}\r\n\r\n.urgent-orders-box {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.urgent-orders-box-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.urgent-orders-box-header h4 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.urgent-orders-box-header span {\r\n  font-size: 12px;\r\n  background: #f1f5f9;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  margin-left: 15px;\r\n}\r\n\r\n.show-all-btn {\r\n  cursor: pointer;\r\n  color: #3b82f6;\r\n  background: none;\r\n  border: none;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  padding-top: 20px;\r\n}\r\n\r\n.urgent-assign-btn {\r\n  flex-shrink: 0;\r\n  padding: 3px 14px;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition:\r\n    opacity 0.2s,\r\n    transform 0.15s;\r\n}\r\n.urgent-assign-btn:hover {\r\n  opacity: 0.85;\r\n  transform: scale(1.04);\r\n}\r\n\r\n.urgent-assign-btn--red,\r\n.urgent-assign-btn--orange,\r\n.urgent-assign-btn--yellow {\r\n  border-radius: 5px;\r\n  height: 27px;\r\n  border: 1px solid lightgray;\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  padding: 5px;\r\n}\r\n\r\n.urgent-delay-label {\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n  margin: 2px 0 0 0;\r\n}\r\n\r\n.dName--clickable {\r\n  cursor: pointer;\r\n  transition: color 0.15s;\r\n}\r\n.dName--clickable:hover {\r\n  color: #3b82f6;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n}\r\n\r\n.driver-orders-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.45);\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.driver-orders-modal {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  width: 420px;\r\n  max-width: 94vw;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n  animation: modalSlideIn 0.2s ease;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n  from {\r\n    transform: translateY(24px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.driver-orders-modal__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 18px 20px 12px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n.driver-orders-modal__title-group {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.driver-orders-modal__title {\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: #111;\r\n  margin: 0;\r\n}\r\n.driver-orders-modal__close {\r\n  background: #f3f4f6;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 30px;\r\n  height: 30px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  color: #555;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.15s;\r\n}\r\n.driver-orders-modal__close:hover {\r\n  background: #e5e7eb;\r\n}\r\n\r\n.driver-orders-modal__subheader {\r\n  padding: 8px 20px;\r\n  background: #f9fafb;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n}\r\n.driver-orders-modal__badge {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  background: #e5e7eb;\r\n  padding: 3px 10px;\r\n  border-radius: 20px;\r\n  flex-shrink: 0;\r\n}\r\n.driver-orders-modal__optimize-btn {\r\n  margin-left: auto;\r\n  font-size: 12px;\r\n  padding: 4px 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.driver-orders-modal__body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.driver-orders-modal__loader {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 40px 0;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n.driver-orders-modal__spinner {\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 3px solid #e5e7eb;\r\n  border-top-color: #3b82f6;\r\n  border-radius: 50%;\r\n  animation: spin 0.7s linear infinite;\r\n}\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.driver-orders-modal__empty {\r\n  text-align: center;\r\n  padding: 48px 0;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n\r\n.driver-order-card {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  padding: 14px 16px;\r\n  background: #fff;\r\n  transition: box-shadow 0.15s;\r\n}\r\n.driver-order-card:hover {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.driver-order-card__top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n.driver-order-card__id {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #111;\r\n}\r\n.driver-order-card__status {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  padding: 3px 10px;\r\n  border-radius: 20px;\r\n}\r\n.status--assigned {\r\n  background: #dbeafe;\r\n  color: #1d4ed8;\r\n}\r\n.status--picked {\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n}\r\n.status--onway {\r\n  background: #d1fae5;\r\n  color: #065f46;\r\n}\r\n\r\n.driver-order-card__meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 10px;\r\n}\r\n.driver-order-card__amount {\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #2563eb;\r\n}\r\n.driver-order-card__delay {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n  border-radius: 20px;\r\n}\r\n.delay--late {\r\n  background: #fee2e2;\r\n  color: #dc2626;\r\n}\r\n.delay--ok {\r\n  background: #dcfce7;\r\n  color: #16a34a;\r\n}\r\n\r\n.driver-order-card__addresses {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n.driver-order-card__addr-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n  font-size: 12px;\r\n  color: #374151;\r\n}\r\n.addr-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  margin-top: 4px;\r\n}\r\n.addr-dot--pickup {\r\n  background: #3b82f6;\r\n}\r\n.addr-dot--drop {\r\n  background: #10b981;\r\n}\r\n.addr-text {\r\n  color: #6b7280;\r\n}\r\n\r\n.driver-active-count {\r\n  display: inline-block;\r\n  background: #dbeafe;\r\n  color: #1d4ed8;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  padding: 2px 8px;\r\n  min-width: 24px;\r\n  text-align: center;\r\n  border-radius: 50%;\r\n  margin: 0px;\r\n}\r\n\r\n.driver-active-count-span {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: right;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
